import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputFieldLabelModule } from '../input-field-label/input-field-label.module';
import { InputTextareaComponent } from './input-textarea.component';
import { InputErrorModule } from '../input-error/input-error.module';

@NgModule({
  declarations: [InputTextareaComponent],
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    InputFieldLabelModule,
    InputErrorModule
  ],
  exports: [InputTextareaComponent],
})
export class InputTextareaModule { }
